export default "__VITE_ASSET__06899753__"